import React from "react";
import { Route, Routes } from "react-router-dom";
// Силлабустарды импорттау
import PDF_AI from "../../syllabus/KazMBS_1_Жасанды интеллект және Python негиз_syllabus_2026 - қаз.pdf";
import PDF_FRONTEND from "../../syllabus/KazMBS_3_Веб қосымшалар даярлау frontend_syllabus_2026 - қаз.pdf";
import PDF_BACKEND from "../../syllabus/KazMBS_4_Веб қосымшалар даярлау backend_syllabus_2026 - қаз.pdf";
import PDF_MOBILE from "../../syllabus/KazMBS_2_Мобильді қосымшалар даярлау_syllabus_2026 - қаз.pdf";
import PDF_DESIGN from "../../syllabus/4_KazMBS_Цифрлык дизайн жане анимация_syllabus_2025.pdf";
import PDF_DRONE from "../../syllabus/6_KazMBS_ЖИ комегимен дрон программалау_syllabus_2025.pdf";

import "./course-card.scss";
import ArrowRight from "../../images/ArrowRight1.svg";
import CardDetailPage from "../card-detail-page/card-detail-page";

const CourseCard = (props) => {
  let pdfPath;

  // Courses.js файлындағы ID-лерге сәйкес силлабусты таңдау
  switch (props.id) {
    case 1: pdfPath = PDF_AI; break;       // AI және Python
    case 2: pdfPath = PDF_MOBILE; break;   // Mobile
    case 3: pdfPath = PDF_FRONTEND; break; // Frontend
    case 4: pdfPath = PDF_BACKEND; break;  // Backend
    case 7: pdfPath = PDF_DESIGN; break;   // Дизайн (егер болса)
    case 8: pdfPath = PDF_DRONE; break;    // Дрон (егер болса)
    default: pdfPath = null;
  }

  return (
    <div className="course_card">
      {props.image && (
        <div className="course_card_image">
          <img src={props.image} alt={props.name} />
        </div>
      )}
      <div className="course_card_header">
        <div className="course_duration">{props.time}</div>
        <div className="course_starting_date">{props.startTime}</div>
        <div className="icon_button">
          <img src={ArrowRight} alt="detail" />
        </div>
      </div>
      <div className="course_card_description">
        <div className="course_card_description_title">{props.name}</div>
        <div className="course_card_description_text">
          {/* Сипаттамадағы жаңа жолдарды (\n) дұрыс көрсету */}
          {props.description.split('\n').map((line, index) => (
            <div key={index} style={{ marginBottom: line ? '5px' : '15px' }}>
              {line}
            </div>
          ))}
        </div>
      </div>
      <div className="course_card_footer">
        <div className="course_card_description_price">{props.price}</div>
        {pdfPath && (
          <a
            className="course_card_footer_dwl_btn"
            href={pdfPath}
            download={`${props.name}_Syllabus.pdf`}
          >
            Силлабусты жүктеу
          </a>
        )}
      </div>

      {/* Routes тек қажет болған жағдайда қолданылады */}
      <Routes>
        <Route path="/products" element={<CardDetailPage {...props} />} />
      </Routes>
    </div>
  );
};

export default CourseCard;